<template>
	<div class="member-order-list">
		<div class="common-header-wrap">
			<mt-header title="订单列表" class="common-header">
				<mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
			</mt-header>
		</div>
		<!-- header -->
		<div class="order-header">
			<ul>
				<li
						class="item"
						v-for="item in orderNav"
						v-bind:key="item.id"
						v-bind:class="{ active: stateType == item.id }"
						v-on:click="setOrderNavActive(item.id)"
				>
					{{ item.name }}
				</li>
			</ul>
		</div>
		<div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
			<div class="order-body" v-if="order_group_list && order_group_list.length">
				<div v-for="item in order_group_list" :key="item.o2o_fuwu_order_id">
					<div class="list">
						<router-link :to="{name:'MemberO2oFuwuOrderDetail',query:{o2o_fuwu_order_id:item.o2o_fuwu_order_id}}">
							<div class="tips-body">
								<span class="tips"> 订单编号: {{ item.o2o_fuwu_order_sn }} </span>
								<span class="title tips statusTips" >{{ item.o2o_fuwu_order_state_text }}</span>
							</div>

							<div class="price">
								合计 : ￥ <i>{{ item.o2o_fuwu_order_amount }}</i>
							</div>
						</router-link>
						<div class="order-list-opratio">
							<!-- 付款 -->
							<button v-if="item.if_pay" @click='pay(item.o2o_fuwu_order_sn)' class="line_red">付款</button>
							<!-- 取消订单 -->
							<button v-if="item.if_cancel" v-on:click="cancel(item.o2o_fuwu_order_id)">取消订单</button>
							<!-- 已服务 -->
							<button v-if="item.if_receive" v-on:click="receive(item.o2o_fuwu_order_id)">已服务</button>
							<!-- 评论 -->
							<button v-if="item.if_evaluate" v-on:click="evaluate(item.o2o_fuwu_order_id)">评论</button>
						</div>
					</div>
				</div>
			</div>
			<empty-record v-else-if="order_group_list && !order_group_list.length"></empty-record>
		</div>
		<mt-popup
				class="middle-popup"
				v-model="showEvaluate"
				popup-transition="popup-fade">
			<div class="body-list">
				<mt-cell title="评分">
					<div class="comment">
						<span class="common-score-wrapper" @click="setStar($event)" ref="star"><i class="iconfont front" :style="{width:score/5*100+'%'}"></i><i class="iconfont back"></i></span>
					</div>
				</mt-cell>

			</div>
			<div class="enter">
				<mt-field
						type="textarea"
						placeholder="请在此输入评价"
						v-model="comment"
				></mt-field>
			</div>
			<mt-button size="large" type="primary" @click="submitEvaluate">提交</mt-button>
		</mt-popup>
	</div>
</template>

<script>
import { getFuwuOrderList, cancelFuwuOrder, receiveFuwuOrder, evaluateFuwuOrder } from '../../../api/memberO2oFuwuOrder'
import { addComplaint } from '../../../api/memberO2oCompliant'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { mapState } from 'vuex'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
  components: {
    EmptyRecord
  },
  name: 'MemberO2oFuwuOrderList',
  data () {
    return {
      comment: '',
      score: 5,
      o2o_fuwu_order_id: 0,
      showEvaluate: false,
      orderNav: [
        {
          'name': '全部',
          'id': ''
        },
        {
          'name': '待付款',
          'id': '10'
        },
        {
          'name': '待服务',
          'id': '20'
        },
        {
          'name': '服务中',
          'id': '30'
        },
        {
          'name': '已完成',
          'id': '40'
        }
      ],
      stateType: this.$route.query.state ? this.$route.query.state : '',
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      order_group_list: false

    }
  },

  computed: {
    ...mapState({
    })
  },
  created: function () {
  },

  methods: {
    submitEvaluate () {
      evaluateFuwuOrder(this.o2o_fuwu_order_id, this.score, this.comment).then(res => {
        this.comment = ''
        this.score = 5
        this.o2o_fuwu_order_id = 0
        this.showEvaluate = false
        this.getOrderList(true)
		  Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    setStar (event) {
      let starWidth = this.$refs.star.offsetWidth
      this.score = Math.ceil(event.offsetX / starWidth * 5)
    },
    evaluate (o2o_fuwu_order_id) {
      this.o2o_fuwu_order_id = o2o_fuwu_order_id
      this.showEvaluate = true
    },
    complaint (order_id) {
      MessageBox.prompt('投诉内容', '').then(({ value, action }) => {
        if (value) {
          addComplaint(order_id, 1, value).then(res => {
            Toast(res.message)
            this.$router.push({ name: 'MemberO2oComplaint' })
          }).catch(function (error) {
            Toast(error.message)
          })
        }
      })
    },
    setOrderNavActive (index) {
      this.stateType = index
      this.getOrderList(true)
    },
    showMessage (message, title) {
      MessageBox.alert(message, title)
    },
    cancel (orderId) {
      MessageBox.confirm('确定要取消该订单吗？').then(action => {
        cancelFuwuOrder(orderId).then(res => {
          this.getOrderList(true)
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    },
    receive (orderId) {
      MessageBox.confirm('确定该订单已服务吗？').then(action => {
        receiveFuwuOrder(orderId).then(res => {
          this.getOrderList(true)
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    },

    pay (paySn) {
      this.$router.push({ name: 'MemberBuyPay', query: { pay_sn: paySn, pay_type: 'o2o_fuwu_pay_new' } })
    },

    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getOrderList(false)
      }
    },
    getOrderList (ifReplace) {
      Indicator.open()
      if (ifReplace) {
        this.loading = false
        this.params.page = 1
        this.isMore = true
      }

      getFuwuOrderList(this.params, this.stateType).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        let tOrderGroup = res.result.o2o_fuwu_order_list

        if (tOrderGroup) {
          if (ifReplace || !this.order_group_list) {
            this.order_group_list = tOrderGroup
          } else {
            this.order_group_list = this.order_group_list.concat(tOrderGroup)
          }
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
	.common-score-wrapper .back{display: block}
	.member-order-list {
		.order-header {
			position: fixed;
			height: 2.2rem;
			width: 100%;
			top: 2rem;
			z-index: 100;
			ul {
				list-style: none;
				width: auto;
				display: flex;
				justify-content: space-around;
				align-content: center;
				align-items: center;
				height: 100%;
				background: rgba(255, 255, 255, 1);
				border-bottom: 1px solid #e8eaed;
				li {
					font-size: 0.7rem;
					color: rgba(124, 127, 136, 1);
					height: 100%;
					text-align: center;
					line-height: 2.2rem;
					border-bottom: 0.1rem solid transparent;
					&.active {
						color: $primaryColor;
						border-bottom-color: $primaryColor;
					}
				}
			}
		}
		.order-body {
			position:relative;padding-top:2.3rem;
			.list {
				width: 100%;
				margin-top: 0.55rem;
				.tips-body {
					height: 2.2rem;
					background: rgba(255, 255, 255, 1);
					box-shadow: 0 1px 0 0 rgba(232, 234, 237, 1);
					display: flex;
					justify-content: space-between;
					padding: 0 0.75rem 0 0.5rem;
					.tips {
						font-size: 0.7rem;
						color: #333333;
						line-height: 2.2rem;
					}
					.statusTips {
						color: #666666;
					}
					img {
						width: 3.8rem;
						height: 3rem;
					}
				}

				.price {
					font-size: 0.7rem;
					color: rgba(78, 84, 93, 1);
					line-height: 2.2rem;
					height: 2.2rem;
					background-color: #fff;
					padding: 0 0.75rem 0 0;
					border-bottom: 1px solid #e8eaed;
					box-sizing: border-box;
					text-align: right;

					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					i {
						font-size: 0.9rem;
						padding-left: 0.25rem;
						font-style: normal;
						&.freight {
							color: rgba(124, 127, 136, 1);
							font-size: 0.6rem;
						}
					}
				}
			}
			.loading-wrapper {
				text-align: center;
				p {
					color: #c3c3c3;
					font-size: 0.6rem;
					font-weight: 'Regular';
					margin: 0.5rem auto;
				}
			}
		}
		.mint-popup {
			width: 100%;
			height: 11.75rem;
			&.middle-popup{width:80%;height: auto}
		}
	}
	.order-list-opratio{height: 2.2rem;display: flex;justify-content: flex-end;background: rgba(255, 255, 255, 1);border-radius: 0.1rem;}
	.order-list-opratio button{width: 4.5rem;height: 1.5rem;font-size: 0.7rem;border-radius: 0.7rem;margin: 0.35rem 0.75rem 0.35rem 0;background-color: #fff;border: 1px solid #ccc;box-shadow: 0 3px 6px 0 rgba(0,0,0,.05);}
	.order-list-opratio .line_red{background-color: #fff;color: #f2270c;border: 1px solid #f2270c;box-shadow: 0 3px 6px 0 rgba(242,39,12,.1);}

</style>
